import { GameMode } from "@rosette/ts/src/business/game/GameMode.js";
import { BotType } from "@rosette/ts/src/business/game/BotType.js";
import type { APIUser } from "@rosette/ts/src/business/api/api_schema.js";
import { KnownLobbySettings } from "@rosette/ts/src/business/game/KnownLobbySettings.js";
import { readBrowserStorage, writeBrowserStorage } from "../storage/browserStorage.js";


const PREFERRED_SETTINGS_KEY = "preferredGameSetupSettings";


export function readPreferredSettings(user: APIUser | null): KnownLobbySettings {
    const defaultGameSettings = KnownLobbySettings.DEFAULT;
    const jsonText: string | null = readBrowserStorage(PREFERRED_SETTINGS_KEY);
    if (jsonText === null)
        return defaultGameSettings;

    let settings = KnownLobbySettings.fromJSON(jsonText, defaultGameSettings);
    if (user)
        return settings;

    const botType = settings.getBotType();
    if (settings.getMode() === GameMode.COMPUTER
        && (botType === BotType.HARD || botType === BotType.PANDA)) {

        settings = settings.withBotType(BotType.MEDIUM);
    }
    return settings;
}


export function writePreferredSettings(settings: KnownLobbySettings) {
    writeBrowserStorage(PREFERRED_SETTINGS_KEY, settings.toJSON());
}
